import classes from './HeaderBarButton.module.css';

export default function HeaderBarButton({ text, onClick }: { text: string; onClick: () => void }) {
    return (
        <div className={classes.HeaderBarButton} onClick={onClick}>
            {text}
        </div>
    );
}
